import _ from 'underscore';

export class SchemaI18n {
  constructor(schema) {
    this.schema = schema;
  }

  value(schemaName, key, value) {
    const entityProperty = _.chain(this.schema.filterProps())
      .result(key)
      .value();
    const localizedVal = _.chain(entityProperty)
      .result('localized')
      .result(value)
      .value();

    return localizedVal || value;
  }

  property(schemaName, key) {
    const property = this.schema.getFilterProperty(key);
    // filter-agent's schema-localizer writes localized property name
    // to property.title instead of property.name
    return property && property.title ? property.title : key;
  }
}
